export const VERIFF_CALLBACK_PATH =
  '/get-started/identity-verification/veriff-callback'

export function getVeriffCallbackUrl() {
  return `${window.location.origin}${VERIFF_CALLBACK_PATH}`
}
